import {Component, OnInit, OnDestroy} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-notification-master',
    templateUrl: './notification-master.component.html',
    styleUrls: ['./notification-master.component.css']
})
export class NotificationMasterComponent implements OnInit, OnDestroy {
    description: string;
    clientId: number;
    status = [];
    statusSelected: number;
    ttypes = [];
    ticketTypeSelected: number;
    ticketTypeId: number;
    categoryLoaded: boolean;
    private baseCategories = [];
    ticketTypes: any;
    cat = [];
    dynamicFields = [];
    priorityType: number;
    columnDefinitions = [];
    ticketType: string;
    ticketTypeSeqNo: number;
    ticket_status = [];
    ststusSelected: number;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;

    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    ticketFieldTicketName = '';
    isDropdown: boolean;
    dropdown = '';
    isCategory: boolean;
    isStatus: boolean;
    dataLoaded: boolean;
    menuDtl = [];
    showSearch = false;
    isLoading = false;
    groups = [];
    menuSelected: number;
    categories = [];
    catSelected: number;

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        //   if (confirm('Are you sure?')) {
                        //       item.createdBy = this.messageService.getUserId();
                        //       if (item.description !== '') {
                        //           this._rest.editChecklist(item).subscribe((res) => {
                        //               this.respObject = res;
                        //               if (this.respObject.success) {
                        //                   // console.log('data--Done');
                        //                   this.notifier.notify('success', 'Updated successfully');
                        //               } else {
                        //                   // console.log('data--Not---Done');
                        //                   this.notifier.notify('error', this.respObject.errorMessage);
                        //               }
                        //           }, (err) => {
                        //               this.notifier.notify('error', JSON.stringify(err));
                        //           });
                        //       } else {
                        //           this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
                        //       }
                        //   }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteNotification({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.totalData = this.totalData - 1;
                                    this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
            }
        });


    }

    ngOnInit() {
        this.dataLoaded = false;
        this.isCategory = false;
        this.isStatus = false;
        this.description = '';
        this.categoryLoaded = true;
        this.ticketTypeSelected = 0;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.displayData = {
            pageNstatusSelectedame: 'Maintain Notification',
            openModalButton: 'Add Notification',
            searchModalButton: 'Search',
            breadcrumb: 'Notification',
            folderName: 'All Notification',
            tabName: 'Notification'
        };


        this.columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            {
                id: 'ticketType', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true
            },
            {
                id: 'status', name: 'Status', field: 'status', sortable: true, filterable: true
            },
            {id: 'cat_id', name: 'Category', field: 'cat_id', sortable: true, filterable: true}
            ,
            {id: 'menu_id', name: 'Menu ', field: 'menu_id', sortable: true, filterable: true}
            ,
            {id: 'group_id', name: 'Group', field: 'group_id', sortable: true, filterable: true}
        ];
        this.messageService.setColumnDefinitions(this.columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.ttypes = this.respObject.details;
                this.ticketTypeSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
        const functionality_Id = 1;
        this._rest.getStatusForClient(this.clientId).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Status', seq: -1});
                this.status = this.respObject.details;
                this.statusSelected = -1;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });

        this._rest.getAdditionalFuncTicketTypeWise(this.clientId, functionality_Id).subscribe((res3) => {
            this.respObject = res3;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Tile'});
                this.menuDtl = this.respObject.details;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', JSON.stringify(err));
        });

        // this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
        //     this.respObject = res1;
        //     if (this.respObject.success) {
        //         // this.respObject.details.unshift({id: 0, name: 'Select support group'});
        //         this.groups = this.respObject.details;
        //         // let x = this.respObject.details;
        //         // console.log(JSON.stringify(x));
        //         // this.groupSelected = this.assignedGroupArray;
        //     } else {
        //         this.notifier.notify('error', this.respObject.errorMessage);
        //     }
        // }, (err) => {
        //     // this.isError = true;
        //     // this.errorMessage = this.messageService.SERVER_ERROR;
        // });
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.description = '';
            this.ticketTypes = [];
            this.ticketTypeSelected = 0;
            this.statusSelected = -1;
            this.menuSelected = 0;
            this.catSelected = 0;
            // for (let i = 0; i < this.menuDtl.length; i++) {
            //     this.menuDtl[i].checked = false;
            // }
            for (let i = 0; i < this.groups.length; i++) {
                this.groups[i].checked = false;
            }
            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }
    }


    save() {
        const data = {
            clientId: this.clientId,
            tickettyp_id: this.ticketTypeSelected,
            status_seq: this.statusSelected,
            menu_id: this.menuSelected,
            group_id: this.selectedGroup,
            cat_id: this.catSelected
        };
        // console.log(JSON.stringify(data));
        if (!this.messageService.isBlankField(data) && this.selectedGroup.length > 0) {
            // console.log("..................."+JSON.stringify(data));
            this._rest.addNotification(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.ticketTypeSelected = 0;
                    this.menuSelected = 0;
                    this.statusSelected = -1;
                    this.catSelected = 0;
                    // for (let i = 0; i < this.menuDtl.length; i++) {
                    //     this.menuDtl[i].checked = false;
                    // }
                    for (let i = 0; i < this.groups.length; i++) {
                        this.groups[i].checked = false;
                    }
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                // this.isError = true;
                // this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getNotifiationMaster(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    // get selectedmenu() {
    //     return this.menuDtl
    //         .filter(opt => opt.checked)
    //         .map(opt => opt.id);
    //
    // }

    get selectedGroup() {
        return this.groups
            .filter(opt => opt.checked)
            .map(opt => opt.id);

    }

    onTicketChange(selectedIndex: any) {
        this.groups = [];
        this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketTypeSelected).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({id: 0, name: 'Select category'});
                this.isError = false;
                this.categories = this.respObject.details;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onCategoryChange(selectedIndex) {
        // this.categoriyName = this.categories[selectedIndex].name;
        this._rest.getSupportGroupByCategory(this.clientId, this.catSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                // this.respObject.details.unshift({id: 0, name: 'Select Support Group'}, {id: -1, name: 'Creator'});
                this.groups = this.respObject.details;
                // this.supportGroupSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }
}
